import type { RailwayFilters, RailwaySort } from "../../railway-query/types";
import { filterTickets } from "../../railway-query/service";
import type { RailwayTransferOption } from "../types";
import { railwayTrain } from "./itineraryRailwayViewService";

/** 按整条中转方案筛选，保留原候选对象供选择与快照使用。 */
export function filterRailwayTransfers(options: RailwayTransferOption[], filters: RailwayFilters) {
  return options.filter((option) => option.legs.every((leg, index) => filterTickets([railwayTrain(leg)], {
    ...filters,
    origins: index === 0 ? filters.origins : [],
    destinations: index === option.legs.length - 1 ? filters.destinations : [],
    departure: index === 0 ? filters.departure : "00:00-24:00",
  }).length > 0));
}

/** 按整条方案的出发、到达或总历时排序。 */
export function sortRailwayTransfers(options: RailwayTransferOption[], sort: RailwaySort) {
  const value = (option: RailwayTransferOption) => sort.key === "duration" ? option.durationMinutes
    : Date.parse(sort.key === "arrive" ? option.arrivalAt : option.departureAt);
  return [...options].sort((left, right) => (value(left) - value(right)) * (sort.direction === "asc" ? 1 : -1));
}

/** 为共享筛选面板提供实际站点与席别候选。 */
export function railwayTransferFilterTrains(options: RailwayTransferOption[]) {
  return options.flatMap((option) => {
    const trains = option.legs.map(railwayTrain);
    const first = trains[0]; const last = trains.at(-1);
    if (!first || !last) return [];
    // 这些聚合行仅供共享控件枚举选项，实际筛选仍逐腿使用原始车次事实。
    return [{ ...first, id: option.optionId, destination_code: last.destination_code, destination_name: last.destination_name,
      seat_types: [...new Set(trains.flatMap((train) => train.seat_types.split("")))].join(""),
      seats: trains.flatMap((train) => train.seats) }];
  });
}
